import gql from 'graphql-tag';

export const ROLES_FRAGMENT = gql`
  fragment RoleInfo on Role {
    id
    name
  }
`;
